<div class="skeleton-table">
    <div class="skeleton-table__header">
        @for (col of colArray; track $index) {
            <div class="skeleton-table__cell skeleton"></div>
        }
    </div>
    <div class="skeleton-table__body">
        @for (row of rowArray; track $index) {
            <div class="skeleton-table__row">
                @for (col of colArray; track $index) {
                    <div class="skeleton-table__cell skeleton"></div>
                }
            </div>
        }
    </div>
</div>
